import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import React, { memo, useEffect, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import IdentificationDocumentForm from '../shared/form-identification-document';
import { FormikErrors, FormikProps, FormikTouched } from 'formik';
import { IdentificationDocument, PersonalDataVM } from 'shell/view-models/personal-data';
import { RegisterOfficeVM } from 'shell/view-models/register-office-practice-vm';

interface IdentificationProps {
  formContext: FormikProps<RegisterOfficeVM>;
  isOpen?: boolean;
  disabled?: boolean;
}

function IdentificationDocumentApplicantComponent({
  formContext,
  isOpen = false,
  disabled = false,
}: IdentificationProps): React.ReactElement {
  const [open, setOpen] = useState<boolean>(isOpen);

  useEffect(() => {
    if (isOpen) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [isOpen]);

  const onChange = useEventCallback(
    (
      key: keyof IdentificationDocument,
      value: IdentificationDocument[keyof IdentificationDocument]
    ) => {
      formContext.setFieldValue('accountholderData', {
        ...(formContext.values.accountholderData || {}),
        identificationDocument: {
          ...(formContext.values.accountholderData?.identificationDocument || {}),
          [key]: value,
        },
      });
    }
  );

  const onFieldsChange = useEventCallback((values: IdentificationDocument) => {
    formContext.setFieldValue('accountholderData', {
      ...(formContext.values.accountholderData || {}),
      identificationDocument: {
        ...(formContext.values.accountholderData?.identificationDocument || {}),
        ...values,
      },
    });
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-subject-attributes-content"
        id="panel-person-subject-attributes-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>{"Documento di riconoscimento dell'intestatario"}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <IdentificationDocumentForm
          onChange={onChange}
          onFieldsChange={onFieldsChange}
          values={formContext.values.accountholderData?.identificationDocument}
          disabled={disabled}
          errors={
            (formContext.errors.accountholderData as FormikErrors<PersonalDataVM>)
              ?.identificationDocument as FormikErrors<IdentificationDocument>
          }
          touched={
            (formContext.touched.accountholderData as unknown as FormikTouched<PersonalDataVM>)
              ?.identificationDocument as unknown as FormikTouched<IdentificationDocument>
          }
        />
      </AccordionDetails>
    </Accordion>
  );
}

IdentificationDocumentApplicantComponent.displayName =
  'Accountholder Identification Document  component';

const IdentificationDocumentComponent = memo(IdentificationDocumentApplicantComponent);

export default memo(IdentificationDocumentComponent);
